
$(function() {
  /* ====================================================
    期間
  ==================================================== */
  $('.js-clone__period').clone().appendTo('.js-item-period');
  /* ====================================================
    ギャラリー
  ==================================================== */
  $('.js-gallery__btn').on('click', function() {
    $('.js-gallery__box-tmb , .gallery__box-tmb-body').animate({ marginLeft: 0 }, 200, 'linear');
    $('#js-container').css({'position': 'fixed'});
    $('.js-gallery__box-tmb li').on('click', function() {
      $('.js-gallery__box-tmb').hide();
      $('.js-gallery__box-tmb , .gallery__box-tmb-body').css('marginLeft', '100%');
      $('#js-container').css({'position': 'relative'});
      setTimeout(function() {
        $('.js-gallery__box-tmb').show();
      }, 100);
    });
  });
  $('.js-gallery__close').on('click', function() {
    $('.js-gallery__box-tmb , .gallery__box-tmb-body').animate({ marginLeft: '100%' }, 200, 'linear');
    $('#js-container').css({'position': 'relative'});
  });
  var slides_con = $('.js-gallery__tmb.is-pc li').length;
  //
  /* ====================================================
    詳細タブ切り替え
  ==================================================== */
  $('.js-def_tab').on('click', function() {
    var $this = $(this);
    if(!($this.hasClass('active'))){
      $('.js-def_tab , .js-def_body').removeClass('active');
      $('.item__description-head').removeClass('is-02');
      $('.item__description-head').removeClass('is-01');
      $this.addClass('active');
      if(!($this.hasClass('is-01'))){
        $('.js-def_body.is-02').addClass('active');
        $('.item__description-head').addClass('is-02');
      }else{
        $('.js-def_body.is-01').addClass('active');
        $('.item__description-head').addClass('is-01');
      }
    }
  });
  //スライダー
  // $('.js-gallery').on("init", function(event, slick) {
  //     $(this).append(
  //       '<div class="slider-num"><span class="now-count"></span>/<span class="all-count"></span></div>'
  //     );
  //     $(".now-count").text(slick.currentSlide + 1);
  //     $(".all-count").text(slick.slideCount);
  //   })
  //   .slick({
  //     fade: true,
  //     autoplay: false,
  //     arrows: true,
  //     prevArrow: '<button type="button" class="slick-prev"><figure></figure><figure></figure></button>',
  //     nextArrow: '<button type="button" class="slick-next"><figure></figure><figure></figure></button>',
  //     asNavFor: '.js-gallery__tmb',
  //   }).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
  //     $(".now-count").text(nextSlide + 1);
  //   });
  // //サムネイル
  // $('.js-gallery__tmb').slick({
  //   autoplay: false,
  //   arrows: false,
  //   slidesToShow: slides_con,
  //   asNavFor: '.js-gallery',
  //   focusOnSelect: true,
  // });
  /* ====================================================
    レビュー
  ==================================================== */

  window.setTimeout(()=>{
    
    console.log('play')
    document.getElementById("product_video").play()
  },500)
  const product_video=document.getElementById("product_video")
product_video.addEventListener("pause",()=>{
  product_video.play()
})
});
